import { useEffect, useMemo, useState } from 'react';
import { apiGetSiteSection } from '../api';

const positiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};

export const useShopPriceFilters = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    apiGetSiteSection('shop_filters')
      .then(({ data }) => setSettings(data?.[0] || null))
      .catch(() => setSettings(null));
  }, []);

  return useMemo(() => {
    const first = positiveNumber(settings?.firstBoundary);
    const second = positiveNumber(settings?.secondBoundary);
    const third = positiveNumber(settings?.thirdBoundary);
    if (first === null || second === null || third === null || !(first < second && second < third)) {
      return { priceOptions: [], priceRanges: {} };
    }
    const symbol = settings.currencySymbol || '₹';
    return {
      priceOptions: [
        { value: 'all', label: settings.allPricesLabel || 'All Prices' },
        { value: 'range1', label: `Under ${symbol}${first}` },
        { value: 'range2', label: `${symbol}${first} - ${symbol}${second}` },
        { value: 'range3', label: `${symbol}${second} - ${symbol}${third}` },
        { value: 'range4', label: `Above ${symbol}${third}` },
      ],
      priceRanges: {
        range1: { min: null, max: first },
        range2: { min: first, max: second },
        range3: { min: second, max: third },
        range4: { min: third, max: null },
      },
    };
  }, [settings]);
};
